module.exports = __webpack_public_path__ + "img/wlcycg.254f057.png";